import { notEmpty, theme, useResponsive } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { VariantProps } from "~/components/home/section-top/variant/types";
import type { oneSectionTopWidgetQueue$key } from "~/queries/__generated__/oneSectionTopWidgetQueue.graphql";

import { Container, Primary, PrimaryRest, Secondary, StyledContentItemRender } from "./styles";

type Props = {
  className?: string;
  reference: oneSectionTopWidgetQueue$key;
} & VariantProps;

export const SectionTopWidgetOne: FunctionComponent<Props> = ({
  className,
  onClick,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment oneSectionTopWidgetQueue on Queue
      @argumentDefinitions(excludeEntityIds: { type: "[String]" }) {
        variantOneItems: items(first: 7, exclude: { entityIds: $excludeEntityIds }) {
          edges {
            node {
              ... on Content {
                ...entityLink
                ...contentItemRenderContent
                ...contentCoverImageContent
              }
            }
          }
        }
      }
    `,
    reference,
  );

  const items =
    data?.variantOneItems?.edges?.map(({ node }) => node).filter(node => notEmpty(node)) ?? [];

  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);
  if (items.length === 0) return null;

  const [leading, one, two, ...rest] = items;

  return (
    <Container className={className}>
      <Primary>
        <StyledContentItemRender
          followButtonSource="HP Section Block"
          reference={leading}
          variant="home-section-lead-primary"
          withTopicLink={{ variant: { type: "main" } }}
          withComment
          onClick={entityId => onClick(entityId)}
        >
          <PrimaryRest>
            <StyledContentItemRender
              reference={one}
              variant="home-secondary"
              skipHighlight
              withComment
              onClick={entityId => onClick(entityId)}
            />
            <StyledContentItemRender
              reference={two}
              variant="home-secondary"
              skipHighlight
              withComment
              onClick={entityId => onClick(entityId)}
            />
          </PrimaryRest>
        </StyledContentItemRender>
      </Primary>

      <Secondary>
        {rest?.slice(0, 4)?.map((node, index) => (
          <StyledContentItemRender
            key={index}
            reference={node}
            variant="home-secondary"
            withComment={isMobile}
            withImage
            onClick={entityId => onClick(entityId)}
          />
        ))}
      </Secondary>
    </Container>
  );
};

SectionTopWidgetOne.displayName = "SectionTopWidgetOne";
